import styled from "styled-components";
import { TableRow } from "@mui/material";

export const Container = styled.div`
	.MuiTableContainer-root {
		max-height: 400px;
	}
`;

export const ColumnActions = styled.div`
	display: flex;
	justify-content: flex-end;
`;

interface ICustomTableRowProps {
	$hasError?: boolean;
}

export const CustomTableRow = styled(TableRow)<ICustomTableRowProps>`
	${({ $hasError, theme }) => $hasError && `background-color: ${theme.errorLight};`}

	> .MuiTableCell-root {
		padding: 6px 16px;
		min-width: 200px;
	}
`;
